import { InputCheck } from '@abb-procure/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormControl, FormRecord, ReactiveFormsModule } from '@angular/forms';
import { SearchFilterValueDto } from '../../types/search-filter-value-dto.type';

@Component({
  selector: 'procure-search-filter-checkbox',
  templateUrl: './search-filter-checkbox.component.html',
  styleUrl: './search-filter-checkbox.component.scss',
  imports: [InputCheck, ReactiveFormsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchFilterCheckbox {
  readonly label = input.required<string>();
  readonly control = input.required<FormRecord<FormControl>>();
  readonly options = input.required<SearchFilterValueDto[] | null>();
}
